import React, { useRef, useCallback } from "react";
import { SECTIONS } from "../PlayerSection/PlayerSection";

export default function DeckInteractionZone({ 
  deck,
  isOpponentDeck,
  playerId,
  topCardHiddenTo,
  setFocusedCard,
  draw,
  createDraggedCard,
  setDeck,
  ationModeText,
  deckClick
}) {
  const handleClick = useCallback(() => {
    if (!isOpponentDeck) deckClick();
  }, [isOpponentDeck, deckClick]);

  const handleHold = useCallback((e) => {
    if (!isOpponentDeck && deck.length > 0) {
      const tmpDeck = [...deck];
      const card = tmpDeck.pop();
      createDraggedCard(card, e);
      setDeck(tmpDeck);
    }
  }, [isOpponentDeck, deck, createDraggedCard, setDeck]);

  const handlePointerEnter = useCallback(() => {
    if (topCardHiddenTo[playerId] !== true && deck.length > 0) {
      const card = deck.at(-1);
      card.position = {
        cardSize: { width: 8, height: 15 },
        section: SECTIONS.DECK
      };
      setFocusedCard({ card });
    }
  }, [deck, playerId, topCardHiddenTo, setFocusedCard]);

  const handlePointerLeave = useCallback(() => {
    setFocusedCard(false);
  }, [setFocusedCard]);

  return (
    <div className="interaction-zone position-absolute top-0 start-0 w-100 h-100">
      <ClickableArea
        onClick={handleClick}
        onHold={handleHold}
        onPointerEnter={handlePointerEnter}
        onPointerLeave={handlePointerLeave}
      >
        <div className="deck-background position-absolute top-0 start-0 h-100 w-100"></div>
        <p className="position-absolute top-0 w-100">{ationModeText}</p>
      </ClickableArea>
    </div>
  );
}


function ClickableArea(props) {
    const timerRef = useRef(null);
    const heldRef = useRef(false);
    const eventRef = useRef(null);

    const handleMouseDown = (event) => {
        heldRef.current = false;
        eventRef.current = event;
        timerRef.current = setTimeout(() => {
            heldRef.current = true;
            props.onHold(eventRef.current); // trigger hold behavior
        }, 200); // 200ms threshold
    };

    const handleMouseUp = () => {
        clearTimeout(timerRef.current);
        if (!heldRef.current) {
            props.onClick(); // trigger normal click
        }
    };

    const handleMouseLeave = () => {
        clearTimeout(timerRef.current); // cancel if they move away
    };

    return (
        <div
            className='click-area position-absolute top-0 start-0 w-100 h-100 pe-auto'
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseLeave}
            onTouchStart={handleMouseDown}
            onTouchEnd={handleMouseUp}
            onTouchCancel={handleMouseLeave}
            onPointerEnter={props.onPointerEnter}
            onPointerLeave={props.onPointerLeave}
        >
            {props.children}
        </div>
    );
}